import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { timer } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment/moment';

class TimeSinceComponent {
    constructor() { }
    ngOnChanges() {
        if (this.startDate) {
            this.timer$ = timer(0, 1000).pipe(map(() => this.formatTime()));
        }
    }
    ngOnInit() { }
    formatTime() {
        if (!this.startDate) {
            return '';
        }
        let duration = moment.duration(moment.utc().diff(moment.utc(this.startDate)));
        const days = Math.floor(duration.asDays());
        const hours = Math.floor(duration.asHours());
        const minutes = Math.floor(duration.asMinutes());
        if (days) {
            if (days > 1) {
                return `${days} days ago`;
            }
            return '1 day ago';
        }
        else if (hours) {
            if (hours > 1) {
                return `${hours} hours ago`;
            }
            return `1 hour ago`;
        }
        else if (minutes) {
            if (minutes > 1) {
                return `${minutes} mins ago`;
            }
            return `1 min ago`;
        }
        else {
            return `Just now`;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TimeSinceComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.1", type: TimeSinceComponent, selector: "fgbcl-time-since", inputs: { startDate: "startDate" }, usesOnChanges: true, ngImport: i0, template: "<div>\r\n  {{ timer$ | async }}\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TimeSinceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-time-since', template: "<div>\r\n  {{ timer$ | async }}\r\n</div>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { startDate: [{
                type: Input
            }] } });

class TimeSinceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TimeSinceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.1", ngImport: i0, type: TimeSinceModule, declarations: [TimeSinceComponent], imports: [CommonModule], exports: [TimeSinceComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TimeSinceModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TimeSinceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TimeSinceComponent],
                    imports: [CommonModule],
                    exports: [TimeSinceComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TimeSinceComponent, TimeSinceModule };
